const Eventlist = [
{
    id:'E00002',
    title:'Dasa',
    subtitle:"L'inizio di un nuovo ciclo",
    body:"L'Alleneis non concede i propri frutti senza nulla in cambio. L'ora è ormai propizia e le Tribù iniziano a disegnare i propri eccedenti, un obolo verso la terra, un piccolo sacrifico per la sopravvivenza di molti...",
    date:'21-22/10/2023',
    address:'Agricampeggio la Rotondola - Pontelatone',
    image: require('../../assets/dasa.jpg')
    },
]

export default Eventlist